import { apiClient } from '../../config/axios.config';
import {
  BASE_URL,
  BASE_TRAVEL_URL,
  BASE_TRAVEL_REQUEST_URL,
  CODE_LIST_URL,
} from '../apiConfig';

const fetchTravelType = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/get-travel-type`,
  );
  return response;
};

const fetchOptionsByTravelType = async id => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/populate-options/${id}`,
  );
  return response;
};

const fetchCommonOptions = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/populate-common-options`,
  );
  return response;
};

const fetchTravelCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/enquiry`,
    payload,
  );
  return response;
};

const fetchTravelRequestEnquiry = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/enquiry`,
    payload,
  );
  return response;
};

const fetchTravelRequestPending = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/get-list`,
    payload,
  );
  return response;
};

const fetchTravelRequestEnquiryFilter = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${CODE_LIST_URL}`,
    payload,
  );
  return response.result;
};

const fetchTravelBookingAgent = async () => {
  const response = await apiClient.get(
    `${BASE_URL}/envision/api/travel/booking-agent`,
  );
  return response;
};

const fetchRiskCountries = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/risk-country`,
    payload,
  );
  return response;
};

const updateRiskCountries = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/save-riskcountry`,
    payload,
  );
  return response;
};

const getTravelBookingOptions = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/travel-request-options`,
    payload,
  );
  return response;
};

const fetchTravelRequestApproval = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/approve-request`,
    payload,
  );
  return response;
};

const fetchTravelOptions = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/get-options`,
    payload,
  );
  return response;
};

const fetchTravelDocumentList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/document-list`,
    payload,
  );
  return response;
};

const uploadTravelDocument = async formData => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/create-document`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

const deleteTravelDocument = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/delete-document`,
    payload,
  );
  return response;
};

const saveTravelBooking = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/save-booking`,
    payload,
  );
  return response;
};

const autocompleteTravelAirline = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/get-airline`,
    payload,
  );
  return response;
};

const confirmTravelBooking = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/confirm-booking`,
    payload,
  );
  return response;
};

const modifyTravelBooking = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/modify-booking`,
    payload,
  );
  return response;
};

const rejectTravelBooking = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/reject-booking`,
    payload,
  );
  return response;
};

const cancelTravelBooking = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/cancel-booking`,
    payload,
  );
  return response;
};

const sendHRTravelApproval = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/send-hr-approval`,
    payload,
  );
  return response;
};

const selectOption = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/select-option`,
    payload,
  );
  return response;
};

const modifyCancelBooking = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_URL}/modify-cancel-booking`,
    payload,
  );
  return response;
};

const createRiskTravelRequest = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/create-travel-risk`,
    payload,
  );
  return response;
};

const cloneTravelRequest = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/clone`,
    payload,
  );
  return response;
};

export {
  fetchTravelType,
  fetchTravelCodeList,
  fetchOptionsByTravelType,
  fetchCommonOptions,
  fetchTravelRequestEnquiry,
  fetchTravelRequestPending,
  fetchTravelRequestEnquiryFilter,
  fetchTravelBookingAgent,
  fetchRiskCountries,
  updateRiskCountries,
  fetchTravelRequestApproval,
  getTravelBookingOptions,
  fetchTravelOptions,
  fetchTravelDocumentList,
  uploadTravelDocument,
  saveTravelBooking,
  autocompleteTravelAirline,
  deleteTravelDocument,
  confirmTravelBooking,
  modifyTravelBooking,
  rejectTravelBooking,
  cancelTravelBooking,
  sendHRTravelApproval,
  selectOption,
  modifyCancelBooking,
  createRiskTravelRequest,
  cloneTravelRequest,
};
